/**
 * 本地登录会话（add-auth-login）。
 *
 * token 持久化到 localStorage（30 天有效期由服务端控制，前端到期后首调用
 * 返回 UNAUTHENTICATED 自动跳登录）。token 明文只存本地，不落日志。
 */
const TOKEN_KEY = 'cms.auth.token'

export function getSessionToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function setSessionToken(token: string): void {
  try {
    window.localStorage.setItem(TOKEN_KEY, token)
  } catch {
    // localStorage 不可用（隐私模式等）时忽略，本次会话仍可用
  }
}

export function clearSession(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY)
  } catch {
    // ignore
  }
}

export function hasSession(): boolean {
  const token = getSessionToken()
  return typeof token === 'string' && token.length > 0
}
